import amplitude from 'amplitude-js';

const visitHomepage = (pageChannel) => {
  return amplitude.getInstance().logEvent('Visit Web Homepage', {
    page_channel: pageChannel,
  });
};

const visitLoginPage = (pageChannel) => {
  return amplitude.getInstance().logEvent('Visit Login Page', {
    page_channel: pageChannel,
  });
};

const setUserProp = (data) => {
  const userProperties = {
    email: data && data.email,
    name: data && data.name,
    is_User: data && data.is_User,
    is_Premium: data && data.is_Premium,
  };

  return amplitude.getInstance().setUserProperties(userProperties);
};

const visitRegisterPage = (pageChannel) => {
  return amplitude.getInstance().logEvent('Visit Register Page', {
    page_channel: pageChannel,
  });
};

const registerSuccess = (email, full_name, channel) => {
  return amplitude.getInstance().logEvent('Register Success', {
    email: email,
    full_name: full_name,
    channel: channel,
  });
};

const registerFailed = (statusMessage, email, channel) => {
  return amplitude.getInstance().logEvent('Register Failed', {
    status_message: statusMessage,
    email: email,
    channel: channel,
  });
};

const loginSuccess = (id, channel, role, email, pageChannel) => {
  return amplitude.getInstance().logEvent('Login Success', {
    user_id: id,
    channel: channel,
    user_role: role,
    email: email,
    page_channel: pageChannel,
  });
};

const loginFailed = (statusMessage, channel, email, pageChannel) => {
  return amplitude.getInstance().logEvent('Login Failed', {
    status_message: statusMessage,
    channel: channel,
    email: email,
    page_channel: pageChannel,
  });
};

const filterPriceOverview = (data) => {
  return amplitude.getInstance().logEvent('Filter Price by Overview', {
    item_brand: data && data.item_brand,
    item_series: data && data.item_series,
    item_type: data && data.item_type,
    item_cylinder: data && data.item_cylinder,
    item_year_start: data && data.item_year_start,
    item_year_end: data && data.item_year_end,
    item_transmission: data && data.item_transmission,
    auction_period: data && data.auction_period,
    item_city: data && data.item_city,
  });
};

const resetFilterOverview = () => {
  return amplitude.getInstance().logEvent('Reset Filter Price by Overview');
};

const filterByPopular = (keyword) => {
  return amplitude.getInstance().logEvent('Filter By Popular', {
    keyword: keyword,
  });
};

const viewDetailByLocation = (data) => {
  return amplitude.getInstance().logEvent('View Detail By Location', {
    item_brand: data && data.item_brand,
    item_series: data && data.item_series,
    item_type: data && data.item_type,
    item_cylinder: data && data.item_cylinder,
    item_year: data && data.item_year,
  });
};

const viewDetailByTime = (data) => {
  return amplitude.getInstance().logEvent('View Detail By Time', {
    item_brand: data && data.item_brand,
    item_series: data && data.item_series,
    item_type: data && data.item_type,
    item_cylinder: data && data.item_cylinder,
    item_year: data && data.item_year,
  });
};

const visitInsightMenu = (pageChannel) => {
  return amplitude.getInstance().logEvent('Insight Menu', {
    page_channel: pageChannel,
  });
};

const visitMarketDB = (pageChannel) => {
  return amplitude.getInstance().logEvent('Market Price DB Menu', {
    page_channel: pageChannel,
  });
};

const viewAcvWebsite = () => {
  return amplitude.getInstance().logEvent('View ACV Website');
};

const viewProfileMenu = () => {
  return amplitude.getInstance().logEvent('Profile Menu');
};

const viewCekHarga = () => {
  return amplitude.getInstance().logEvent('View Cek Harga Kendaraan');
};

const clickNextVehicle = (data) => {
  return amplitude.getInstance().logEvent('Next Vehicle Check Price', {
    item_brand: data && data.item_brand,
    item_series: data && data.item_series,
    item_type: data && data.item_type,
    item_cylinder: data && data.item_cylinder,
    item_year: data && data.item_year,
    item_transmission: data && data.item_transmission,
    item_city: data && data.item_city,
  });
};

const clickNextExterior = (data) => {
  return amplitude.getInstance().logEvent('Next Eksterior Check Price', {
    had_accident: data && data.had_accident,
    is_repaint: data && data.is_repaint,
    had_scratch: data && data.had_scratch,
    had_dent: data && data.had_dent,
  });
};

const clickNextInterior = (data) => {
  return amplitude.getInstance().logEvent('Next Interior Check Price', {
    is_interior_complete: data && data.is_interior_complete,
    had_scratch: data && data.had_scratch,
    is_function_fine: data && data.is_function_fine,
    is_ever_change: data && data.is_ever_change,
  });
};

const clickNextMechanical = (data) => {
  return amplitude.getInstance().logEvent('Next Mechanical Check Price', {
    is_function_fine: data && data.is_function_fine,
    is_ever_broke: data && data.is_ever_broke,
    has_been_flooded: data && data.has_been_flooded,
    is_ever_change: data && data.is_ever_change,
  });
};

const clickNextFrame = (data) => {
  return amplitude.getInstance().logEvent('Next Frame Check Price', {
    is_ever_broke: data && data.is_ever_broke,
    is_repair: data && data.is_repair,
  });
};

const clickUpgradePremium = (pageChannel) => {
  return amplitude.getInstance().logEvent('Upgrade Premium', {
    page_channel: pageChannel,
  });
};

const clickExtendPremium = () => {
  return amplitude.getInstance().logEvent('Extend Premium');
};

const marketpriceFilterSuccess = (data) => {
  return amplitude.getInstance().logEvent('MAP Filter Success', {
    item_brand: data && data.item_brand,
    item_series: data && data.item_series,
    item_type: data && data.item_type,
    item_cylinder: data && data.item_cylinder,
    auction_period: data && data.auction_period,
    item_model: data && data.item_model,
    item_grade: data && data.item_grade,
    item_transmission: data && data.item_transmission,
    item_year_start: data && data.item_year_start,
    item_year_end: data && data.item_year_end,
    item_odometer_start: data && data.item_odometer_start,
    item_odometer_end: data && data.item_odometer_end,
    item_color: data && data.item_color,
    item_owner: data && data.item_owner,
    item_city: data && data.item_city,
    item_id: data && data.item_id,
    item_stnk: data && data.item_stnk,
    item_bpkb: data && data.item_bpkb,
    data_result: data && data.data_result,
  });
};

const marketpriceFilterFailed = (data) => {
  return amplitude.getInstance().logEvent('MAP Filter Failed', {
    status_message: data && data.status_message,
    status_code: data && data.status_code,
  });
};

const marketpriceFilterReset = () => {
  return amplitude.getInstance().logEvent('Reset MAP Filter');
};

const viewPrivacyPolicy = () => {
  return amplitude.getInstance().logEvent('View Privacy Police');
};

const addWidgetSuccess = (data) => {
  return amplitude.getInstance().logEvent('Add Widget Success', {
    widget_name: data && data.widget_name,
    chart_type: data && data.chart_type,
    data_display: data && data.data_display,
    auction_period: data && data.auction_period,
    ...data.filters,
  });
};

const addWidgetFailed = (error) => {
  return amplitude.getInstance().logEvent('Add Widget Failed', {
    status_message: error && error.status_message,
    status_code: error && error.status_code,
  });
};

const deleteWidgetSuccess = (data) => {
  return amplitude.getInstance().logEvent('Delete Widget', {
    widget_name: data && data.widget_name,
    chart_type: data && data.chart_type,
    data_display: data && data.data_display,
    auction_period: data && data.auction_period,
    ...data.filters,
  });
};

const cancelAddWidget = () => {
  return amplitude.getInstance().logEvent('Cancel Add Widget');
};

const loginPopUp = (pageChannel) => {
  return amplitude.getInstance().logEvent('Pop Up Login', {
    entry_point: pageChannel,
  });
};

export {
  visitHomepage,
  visitLoginPage,
  visitRegisterPage,
  registerSuccess,
  registerFailed,
  loginSuccess,
  loginFailed,
  filterPriceOverview,
  resetFilterOverview,
  filterByPopular,
  viewDetailByLocation,
  viewDetailByTime,
  visitInsightMenu,
  visitMarketDB,
  viewAcvWebsite,
  viewProfileMenu,
  viewCekHarga,
  clickNextVehicle,
  clickNextExterior,
  clickNextInterior,
  clickNextMechanical,
  clickNextFrame,
  clickUpgradePremium,
  clickExtendPremium,
  marketpriceFilterSuccess,
  marketpriceFilterFailed,
  marketpriceFilterReset,
  viewPrivacyPolicy,
  cancelAddWidget,
  loginPopUp,
  addWidgetSuccess,
  addWidgetFailed,
  deleteWidgetSuccess,
  setUserProp,
};
